/* eslint-disable
    func-names,
    no-shadow,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// Collection of all SalesPerson.
const deps = ['Person', 'Collection'];
const factory = function (Person, Collection) {
  let SalesPersonCollection;
  return (SalesPersonCollection = (function () {
    SalesPersonCollection = class SalesPersonCollection extends Collection {
      static initClass() {
        this.prototype.$id = 'sales';
        this.prototype.$resource = 'person';
        this.prototype.$type = Person;
      }

      $url() {
        return `${super.$url()}/sales/`;
      }

      $init() {
        super.$init();

        // Automatically fetch the first time this collection is created.
        if (this.$lastUpdated === 0) {
          return this.$fetch();
        }
      }
    };
    SalesPersonCollection.initClass();
    return SalesPersonCollection;
  })());
};

factory.$inject = deps;

const moduleDeps = [require('data/model/person').name, require('data/util').name];

module.exports = angular
  .module('bench.data.collection.salesPerson', moduleDeps)
  .factory('SalesPersonCollection', factory);
